module.exports = __webpack_public_path__ + "media/receive-chat.2a23bc26.mp3";